import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import FiveHundredError from '../shared/FiveHundredError';
export const COPY = {
  error: {
    id: 'OpenEndedCoding.TrainingFlow.error',
    defaultMessage: 'An error occurred during training',
    description: '[Type: Header][Vis: med] - OEC training error'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    container: {
      width: '500px',
      margin: theme.spacing[9]
    }
  };
});
const TrainingError = () => {
  const classes = useStyles();
  return _jsx(Box, {
    className: classes.container,
    children: _jsx(FiveHundredError, {
      title: t(COPY.error)
    })
  });
};
export default TrainingError;